export default "__VITE_ASSET__bb405828__"